import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { CartModel } from "@insite/client-framework/Types/ApiModels";
import {
    DiscrepancyCollectionParam,
    DiscrepancyCollectionResult,
    DiscrepancyDetailsResult,
} from "@tKgpco/Services/DiscrepancyService";
import { ItemTrackingCollectionParam, ItemTrackingCollectionResult } from "@tKgpco/Services/ItemTrackingService";
import { MessageCollectionModel } from "@tKgpco/Services/LoadMessageCollection";
import { RMACollectionParam, RMACollectionResult, RMADetailsResult } from "@tKgpco/Services/RMAService";
import { DiscrepancyHistoryState } from "@tKgpco/Store/Data/DiscrepancyHistory/DiscrepancyState";
import { ItemTrackingState } from "@tKgpco/Store/Data/ItemTracking/ItemTrackingState";
import { RMAHistoryState } from "@tKgpco/Store/Data/RMA/RMAState";
import { Draft } from "immer";

const initialState: ItemTrackingState = {
    isLoading: false,
    itemTrackingCollection: null,
    itemTrackingParams: {
        page: 1,
    },
};

const reducer = {
    "Custom/ItemTracking/BeginLoadItemTrackingCollection": (
        draft: Draft<ItemTrackingState>,
        action: { params: ItemTrackingCollectionParam },
    ) => {
        draft.isLoading = true;
        draft.itemTrackingParams = action.params;
        draft.itemTrackingCollection = null;
    },

    "Custom/ItemTracking/CompleteLoadItemTrackingCollection": (
        draft: Draft<ItemTrackingState>,
        action: { result: ItemTrackingCollectionResult },
    ) => {
        draft.isLoading = false;
        draft.itemTrackingCollection = action.result;
    },
    "Custom/ItemTracking/ResetItemTrackingCollection": (
        draft: Draft<ItemTrackingState>,
        action: { result: ItemTrackingCollectionResult },
    ) => {
        draft.isLoading = false;
        draft.itemTrackingCollection = null;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
